import { FC } from 'react';

import AppButton from '@/shared/ui/AppButton';

interface Props {
  filesCount: number;
  handleOpen: () => void;
}

const FileManagerButton: FC<Props> = ({ filesCount, handleOpen }) => {
  return (
    <AppButton type="button" variant="secondary" size="small" onClick={() => handleOpen()}>
      {filesCount ? `${filesCount} files` : 'Upload files'}
    </AppButton>
  );
};

export default FileManagerButton;
